<template>
  <div class="component-upload-image">
    <el-upload
      ref="imageUpload"
      class="upload-demo "
      action="#"
      :auto-upload="false"
      :on-change="handleBeforeUpload"
      :show-file-list="false"
    >
      <el-button class="btn" size="small" type="primary">更换头像</el-button>
    </el-upload>

  </div>
</template>

<script>
import { Loading } from 'element-ui'
import {  upload } from '@/http/index'

let loadingInstance;
export default {
  components: {
  },
  props: {
    // 图片数量限制
    limit: {
      type: Number,
      default: 5
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 2
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"]
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      fileList: [],
      isRequest: true,
      showEditImg: false
    };
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    }
  },

  methods: {
    // 上传前loading加载
    handleBeforeUpload(file) {
      var  isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.raw.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
        this.$refs.imageUpload.clearFiles();
        return;
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
          this.$refs.imageUpload.clearFiles();
          return;
        }
      }
      loadingInstance = Loading.service({
        lock: true,
        text: '正在上传图片，请稍候...',
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      this.uploadRequest(file.raw)
    },
    async uploadRequest(res) {
      const files = res;
      const formData = new FormData();
      formData.append("file", files);
      formData.append("token", localStorage.getItem('token'));
      formData.append("secret", localStorage.getItem('secret'));
      formData.append("hospital_id", localStorage.getItem('hospital_id'));
      upload(formData).then(res2 => {
        this.uploadedSuccessfully(res2.data.path);
      }).catch(err => {
        this.$refs.imageUpload.clearFiles();
        loadingInstance.close();
        this.$message.error(err.msg);
      })
    },
    // 上传结束处理
    uploadedSuccessfully(url) {
      this.number = 0;
      this.$emit("changeImg", url);
      this.$refs.imageUpload.clearFiles();
      loadingInstance.close();
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep.hide .el-upload--picture-card {
    display: none;
}
// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
    transition: all 0s;
}

::v-deep .el-list-enter, .el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}
.btn{
    line-height: 1;
    cursor: pointer;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #303030;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #EEEEEE;
    padding: 4px 10px;
    margin-left: 16px;
    background-color: #fff;
}

</style>

